import getValue from './get-value'
import phone from './phone'
import strPad from './strPad'

export default (Vue) => {
  Vue.filter('getValue', getValue)
  Vue.filter('phone', phone)
  Vue.filter('strPad', strPad)
}



// WEBPACK FOOTER //
// ./src/filters/index.js